import { DesignSystem } from "../design-system.js";
import { Field } from "./field.js";
import { FieldTemplate } from "@fluentui/web-components";
import { styles as FieldStyles } from "./field.styles.js";
/**
 * The Fabric Field component.
 *
 * @public
 */
export const definition = Field.compose({
    name: `${DesignSystem.prefix}-field`,
    template: FieldTemplate,
    styles: FieldStyles,
    shadowOptions: {
        mode: DesignSystem.shadowRootMode
    }
});
//# sourceMappingURL=field.definition.js.map